import Typography from "@mui/material/Typography";
import { FC, ReactNode } from "react";
import { COLOR_BLACK } from "shared/theme/colors";
import { StyledItem, StyledText } from "./styled";

export type DetailsItemProps = {
  isFirst: boolean;
  isLast: boolean;
  value: string | null;
  height?: string;
  children?: ReactNode;
};

const DetailsItem: FC<DetailsItemProps> = ({
  isFirst,
  isLast,
  value,
  height,
  children,
}) => (
  <StyledItem isFirst={isFirst} isLast={isLast} height={height}>
    <StyledText>
      {children || (
        <Typography variant="bodyMRegular" color={COLOR_BLACK}>
          {value}
        </Typography>
      )}
    </StyledText>
  </StyledItem>
);

export default DetailsItem;
